import { getIcon } from './getIcon';
import { STSUI_COIN_TYPE, STSUI_DECIMALS, SUI_COIN_TYPE } from './stsuiConstants';
// The SUI Multiplier pool lets users deposit / receive either SUI (default) or
// stSUI. The selector is scoped to this pool only.
export const SUI_MULTIPLIER_POOL_ID = '0xccda433a3324dc743478c7f79cce584628f6303501281167a3f4b386187c8c63';
export const isSuiMultiplierPool = (poolId) => poolId === SUI_MULTIPLIER_POOL_ID;
// Options rendered in the "Deposit Token:" / "Withdraw Token:" selectors.
export const SUI_MULTIPLIER_TOKEN_OPTIONS = [
    { symbol: 'SUI', icon: getIcon('sui') },
    { symbol: 'stSUI', icon: getIcon('stsui') },
];
// Resolve a chosen token symbol ('SUI' | 'stSUI') to its coin type.
export const getSuiMultiplierCoinType = (selectedSymbol) => selectedSymbol === 'stSUI' ? STSUI_COIN_TYPE : SUI_COIN_TYPE;
// stSUI wallet balance (decimal string) sourced from the wallet balances map.
export const getStsuiWalletBalance = (walletBalancesMap) => (parseFloat((walletBalancesMap === null || walletBalancesMap === void 0 ? void 0 : walletBalancesMap.get(STSUI_COIN_TYPE)) || '0') / Math.pow(10, STSUI_DECIMALS)).toString();
// Convert a SUI to its equivalent stSUI
export const convertSuiToStsui = (suiAmount, exchangeRate) => {
    const amount = parseFloat(suiAmount || '0');
    if (!exchangeRate || exchangeRate <= 0)
        return '0';
    if (!amount)
        return suiAmount;
    return (amount / exchangeRate).toString();
};
